<!-- 切换身份 -->
<template>
  <t-form
    :data="formData"
    :rules="rules"
    :labelWidth="80"
    @reset="onReset"
    @submit="onSubmit"
  >
    <t-form-item label="身份" name="Identity" style="margin-top: 20px">
      <t-select v-model="formData.Identity" class="demo-select-base">
        <t-option
          v-for="item in Identitys"
          :key="item.identityId"
          :value="item.identityId"
          :label="item.identityName"
        ></t-option>
      </t-select>
    </t-form-item>
    <t-form-item style="margin-top: 40px">
      <t-space size="10px" style="margin-left: 50px">
        <t-button
          theme="default"
          wang_btn95
          wang_defaultForm
          variant="base"
          type="reset"
          v-if="props.defaultState"
          >取消</t-button
        >
        <t-button theme="primary" wang_btn95 type="submit">确定</t-button>
      </t-space>
    </t-form-item>
  </t-form>
</template>

<script setup>
import Cookies from "js-cookie";
import {
  onMounted,
  onUnmounted,
  ref,
  reactive,
  defineProps,
  defineEmits,
} from "vue";
import { getUserIdentity } from "@/api/login.js";
const emit = defineEmits(["close", "submitbtn"]);
const props = defineProps(["defaultState", "identity"]);
const userInfo = reactive(Cookies.get("userInfo"));
const getToken = Cookies.get("tokenValue");
const Identitys = ref([]);
const rules = { Identity: [{ required: true, message: "请选择身份" }] };
const formData = reactive({
  Identity: props.identity, // 身份id
});
// 获取身份
const getuserIdentity = () => {
  if (!getToken) {
    return;
  }
  getUserIdentity().then((res) => {
    if (res.code === 1) {
      console.log(res.data);
      Identitys.value = res.data;
    }
  });
};
onMounted(() => {
  getuserIdentity();
});
// 选择身份登录确定
const onSubmit = ({ validateResult, firstError }) => {
  if (validateResult === true) {
    emit("submitbtn", formData.Identity);
  } else {
    //
  }
};
// 取消重置
function onReset() {
  emit("close");
}
</script>
